import styled from 'styled-components';
import CustomButton from 'styles/buttonStyled';
import { Link } from 'react-router-dom';

export const WebContainerStyled = styled.div`
  max-height: 100vh;
  box-sizing: border-box;
  align-items: center;
  @media only screen and (max-width: 600px) {
    height: 100%;
    flex-direction: column;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    justify-content: center;
  }
`;

export const ContainerTopStyled = styled.div`
  display: flex;
  height: 8vh;
  margin-bottom: 15px;
  justify-items: center;
  @media only screen and (max-width: 600px) {
    height: 100%;
    flex-direction: column;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    justify-content: center;
  }
`;

export const ContainerBodyStyled = styled.div`
  display: flex;
  box-sizing: border-box;
  padding-left: 10%;
  padding-right: 10%;
  margin-bottom: 20px;
  align-items: center;
  @media only screen and (max-width: 600px) {
    height: 100%;
    flex-direction: column;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    justify-content: center;
  }
`;

export const ContainerButtomStyled = styled.div`
  height: 34vh;
  background: #0e86f4;
  @media only screen and (max-width: 600px) {
    height: 100%;
    flex-direction: column;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    justify-content: center;
  }
`;

export const WebBoxStyled = styled.div`
  width: 37.2%;
  height: 550px;
  background-color: white;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 5.5%;
  @media only screen and (max-width: 600px) {
    width: 100%;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    padding: 0.8rem;
    margin-right: 0px;
    margin-bottom: 1.2rem;
  }
`;

export const MobileContainerStyled = styled.div`
  height: 100%;
  width: 100%;
  flex-direction: column-reverse;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  justify-content: space-between;
`;

export const MobileBoxStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-height: 450px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 0.8rem;
  margin-right: 0px;
  margin-bottom: 1.2rem;
`;

export const VideoBoxStyled = styled.div`
  width: 100%;
`;

export const ContainerContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  width: 100%;
`;

export const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

export const RowStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TitleStyled = styled.div`
  font-family: Mulish;
  font-style: normal;
  font-weight: bold;
  font-size: 1.5rem;
  text-align: center;
  letter-spacing: 0.5px;
  color: var(--cl_text_primary);
  &.top-up {
    margin-top: -20px;
  }
  &.normal {
    font-weight: normal;
  }
  &.small {
    font-size: 0.9rem;
  }
  &.medium {
    font-size: 1.5rem;
  }
  &.large {
    font-size: 3rem;
  }
`;

export const TextStyled = styled.div`
  font-size: 1rem;
  color: var(--cl_text_primary);
  text-align: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  &.small {
    font-size: 0.9rem;
  }
  &.error {
    color: var(--cl_error500);
    margin-bottom: 6px;
  }
  > span {
    font-weight: bold;
  }
`;

export const ButtonStyled = styled(CustomButton)`
  width: 100%;
  font-size: 1rem !important;
  border-radius: 0.9rem !important;
  height: 40px !important;
  &[disabled] {
    background-color: var(--cl_primary400) !important;
    border-color: var(--cl_primary400) !important;
    color: var(--cl_white) !important;
    &:hover {
      background-color: var(--cl_primary400) !important;
      border-color: var(--cl_primary400) !important;
      color: var(--cl_white) !important;
    }
  }
  &[disabled] > span {
    color: var(--cl_white) !important;
  }
`;

export const LinkStyled = styled(Link)`
  &:hover {
    color: var(--cl_primary);
    text-decoration: underline;
  }
`;
